module.exports = __webpack_public_path__ + "f49f1ff87cfd16ed21458137f2254475.svg";